import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutComponent } from './layout/layout.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [LayoutComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.component.html',
})
export class AppComponent {
  private translate = inject(TranslateService);

  constructor() {
    // Initialize i18n
    this.translate.addLangs(['it', 'en']);
    this.translate.setDefaultLang('it');

    // Try to use browser language, fallback to Italian
    const browserLang = this.translate.getBrowserLang();
    const langToUse = browserLang && ['it', 'en'].includes(browserLang) ? browserLang : 'it';

    // Check if user has a saved language preference
    const savedLang = localStorage.getItem('app-language');
    this.translate.use(savedLang || langToUse);
  }
}
